<template>
  <div class="tags tags-list">
    <span
      v-if="label"
      class="tags-list-label"
    >
      {{ label }}
    </span>
    <b-tag
      v-for="tag in tags"
      :key="tag.id"
      class="tag-link"
      :class="{ selected: isSelected(tag), existing: exists(tag)}"
      @click.exact.native="addTag(tag)"
    >
      <a
        :href="`/bookmarks/f/${tag}`"
        class="tag-non-link"
        @click.exact.prevent
      >{{ tag }}</a>
    </b-tag>
  </div>
</template>

<script>
  export default {
    name: 'TagList',
    props: ['label', 'tags', 'selectedTags', 'existingTags'],
    methods: {
      addTag(tag) {
        this.$emit('tagClicked', tag)
      },
      isSelected(tag) {
        let val = false
        if (this.selectedTags) {
          val = this.selectedTags.includes(tag)
        }

        return val
      },
      exists(tag){
        return this.existingTags && this.existingTags.indexOf(tag) !== -1
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tags-list {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .tags-list-label {
    font-size: 14px;
    color: #aeaeae;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;
  }

  .tag-link {
    cursor: pointer;
    transition: all .25s ease;

    &:not(.selected):hover {
      background-color: #dddde9;
    }
    &.existing{
      border: 1px solid #6c83ff6e;
    }
  }
  .tag-non-link {
    color: #4a4a4a;
  }
  .tag.selected .tag-non-link {
    color: #fff;
  }

  .tags-list {

  }
</style>
